/**
 * @description 驗證狀態 ID (enum)
 */
export enum AuthStatusIdEnum {
  /** 通過 */
  Pass = 'PASS',
  /** 成功 */
  Success = 'SUCCESS'
}
